'use es6';

import { useTheme } from 'foundations-theming/utils';
import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getTableLabel } from '../../../../utils/table-utils';
import { useTableSource } from '../SourceMeta';
import { record } from 'react-immutable-proptypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeletedPropertyFilterLabel = ({
  filter
}) => {
  const theme = useTheme();
  const {
    field: {
      table,
      name: propertyName
    }
  } = filter;

  // a deleted property could still reference a valid table
  const source = useTableSource(table);
  const tableLabel = getTableLabel(table, source);
  const errorMessage = I18n.text('reporting-snowflake.metadata-errors.invalid-property');
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("span", {
      style: {
        display: 'block',
        fontWeight: 600,
        marginBottom: -4
      },
      children: tableLabel
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: errorMessage,
      children: /*#__PURE__*/_jsx("span", {
        style: {
          color: theme.color['text-alert-default']
        },
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx("strong", {
            children: propertyName
          })
        })
      })
    })]
  });
};
DeletedPropertyFilterLabel.propTypes = {
  /**
   * instance of <Filter>
   */
  filter: record.isRequired
};
export default DeletedPropertyFilterLabel;